import classNames from 'clsx';
import React from 'react';

import styles from './CashOutContainer.scss';

interface Props {
  title: React.ReactNode;
  className?: string;
  hasError?: boolean;
}

const CashOutContainer: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  className,
  hasError,
  children
}) => (
  <div className={classNames(styles.container, hasError && styles.error, className)}>
    <span className={styles.title}>{title}</span>
    {children}
  </div>
);

export default CashOutContainer;
